import { SpacingType } from "@/lib/types";
import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLDivElement["className"];
  id?: HTMLDivElement["id"];
  padding?: SpacingType;
}>;

export default function ScrollXContainer({
  children,
  className,
  id,
  padding,
}: Props) {
  const styles: CSSProperties = {
    width: "100%",
    maxWidth: "var(--page-container-max-width)",
    margin: "0 auto",
    padding: padding ? `var(--spacing-${padding})` : 0,
    overflowX: "auto",
  };

  return (
    <div className={className} id={id} style={styles}>
      {children}
    </div>
  );
}
